import Vue from 'vue'
export default {

    //成功
    success : function(text, title){
        title   = title || '成功';
        text    = text || '操作成功！';

        iziToast.success({
            timeout: 3000,
            title: title,
            message: text,

            position: 'topRight',
            transitionIn: 'bounceInRight',
        });
    },

    //失败
    error : function(text, title){
        title   = title || '错误';
        text    = text || '操作失败，请重试！';

        iziToast.error({
            timeout: 3000,
            title: title,
            message: text,

            position: 'topRight',
            transitionIn: 'bounceInRight',
        });
    },

    //通知
    notice : function(text, title){
        title   = title || '通知';
        text    = text || '您有一条通知';

        iziToast.info({
            timeout: 3000,
            title: title,
            message: text,

            position: 'topRight',
            transitionIn: 'bounceInRight',
        });
    }
}


// WEBPACK FOOTER //
// ./src/common/Notify.js